/**
 * A bar across the top of the page saying what you are looking at.
 *
 * Preview shows unpublished content on the real site, at the real address, with the real
 * styling - which is the point, and also the danger. Without something saying so, a draft
 * that reads well is indistinguishable from the live page, and the failure mode is an
 * editor telling a colleague "it's live" because they were looking at their own draft.
 *
 * So it is deliberately hard to miss: fixed, full width, above everything. It is not the
 * place for restraint.
 *
 * Leaving preview needs a reload rather than a re-render: the pages already fetched are
 * drafts, and the honest way to get back to the published site is to ask for it again.
 */
import { exitPreview } from '../lib/preview';
import { useSite } from '../lib/site-context';

export default function PreviewBanner() {
  const { t } = useSite();

  const leave = () => {
    exitPreview();
    window.location.reload();
  };

  return (
    <div
      role="status"
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-x-4 gap-y-1
                 bg-ink-strong px-5 py-2 text-center text-body-sm text-white"
    >
      <span>{t('preview.notice')}</span>
      <button
        type="button"
        onClick={leave}
        className="underline underline-offset-4 transition hover:opacity-80
                   focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
      >
        {t('preview.exit')}
      </button>
    </div>
  );
}
